
import { Vue, Options, prop } from "vue-class-component";
class Props {
  direction = prop<string>({
    default: "",
    type: String
  });
}

@Options({})
export default class SortIcon extends Vue.with(Props) {
}
